export default "__VITE_ASSET__O5obj4d8__"